import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Common";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const reset = params.get("mode") === "reset";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!token) { setError("Link non valido o scaduto"); return; }
    api.get(`/auth/invite/${encodeURIComponent(token)}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e)));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setError("La password deve avere almeno 8 caratteri"); return; }
    if (pw !== pw2) { setError("Le due password non coincidono"); return; }
    setBusy(true); setError("");
    try { await api.post("/auth/set-password", { token, password: pw }); setDone(true); } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6 py-12">
      <div className="w-full max-w-sm fade-up" data-testid="set-password-page">
        <Logo className="h-12" />
        <h2 className="mt-10 font-display text-3xl font-extrabold">{reset ? "Nuova password" : "Scegli la password"}</h2>
        {info && !done && <p className="mt-2 text-sm text-muted-foreground" data-testid="set-password-user">Account di {info.name} · {info.email}</p>}
        {done ? (
          <div className="mt-8 space-y-4" data-testid="set-password-done">
            <div className="border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800">Password impostata. Ora puoi accedere con la tua email.</div>
            <Button asChild className="h-12 w-full"><Link to="/login" data-testid="set-password-login-link">Vai all'accesso</Link></Button>
          </div>
        ) : info ? (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="set-password-form">
            <div><Label className="micro-label">Nuova password (almeno 8 caratteri)</Label><Input type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 h-12" data-testid="set-password-input" /></div>
            <div><Label className="micro-label">Ripeti la password</Label><Input type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5 h-12" data-testid="set-password-confirm-input" /></div>
            {error && <div className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="set-password-error">{error}</div>}
            <Button type="submit" disabled={busy} className="h-12 w-full text-base" data-testid="set-password-submit">{busy ? "Salvataggio…" : "Imposta password"}</Button>
          </form>
        ) : error ? (
          <div className="mt-8 space-y-4">
            <div className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="set-password-error">{error}</div>
            <p className="text-sm text-muted-foreground">{reset ? "Puoi chiedere un nuovo link dalla pagina Password dimenticata." : "Se era un invito, chiedi all'amministratore di reinviarlo; se hai già un account, usa Password dimenticata."}</p>
            <div className="flex gap-4 text-sm"><Link to="/password-dimenticata" className="underline" data-testid="set-password-forgot-link">Password dimenticata</Link><Link to="/login" className="underline">Torna all'accesso</Link></div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
